import { Component, OnInit } from '@angular/core';
import { FilterComponentBase } from 'src/app/main/filter-component-base';
import { UserService } from 'src/app/service/user.service';

@Component({
  selector: 'app-filter-numeric',
  templateUrl: './filter-numeric.component.html',
  styleUrls: ['./filter-numeric.component.scss']
})
export class FilterNumericComponent extends FilterComponentBase implements OnInit {

  constructor() {
    super()
  }

  ngOnInit() {
  }

}
